/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

/* eslint-disable prefer-const */
/**
 * Collection methods
 * -----------------------------------------------------------------------------
 *
 * @namespace collection
 */

import axios from 'axios';
import detectIt from 'detect-it';

const createHistory = require('history').createBrowserHistory;

const history = createHistory();

const collectionMethods = {

  data() {
    return {
      collection: {
        title: null,
        description: null,
        image: null,
        products: [],
        pagination: {},
        activeFilters: [],
      },
    };
  },

  methods: {
    _initCollection() {
      // stop parsing if we are not in the collection template
      if (app.currentTemplate !== 'collection') {
        return;
      }

      // To Define Priority of products - for A/B Testing Pattern Page collections only (https://www.hulkapps.com/pages/patterns-shopify-ab-testing-optimization)
      let product_tags = [];
      $(app.selectors.productObj).each((index, item) => {
        const productObj = $(item).html();
        const productData = JSON.parse(productObj);
        const product = productData.product;
        const optionsWithValues = productData.options_with_values;
        product.current_variant = product.variants[0];
        product.options_with_values = optionsWithValues;
        const coll_handle = $('.patterns_categories').attr('data-collection-handle');
        let priority_img = '';
        let priority_tag = '';
        // assign the product cart limit
        product.tags.forEach((tag) => {
          if (tag.indexOf('priority') >= 0) {
            priority_img = tag.replace('priority-', '');
            priority_tag = tag;
          }
          product.priority_img = priority_img;
          product.priority_tag = priority_tag;
          let available_tag = true;
          for (let i = 0; i < product_tags.length; i++) {
            if (product_tags[i].handle == tag) {
              available_tag = false;
              return false;
            }
          }

          if (available_tag && tag.indexOf(coll_handle) > -1 && tag.indexOf('priority') < 0) {
            const coll_pro_tag = {};
            coll_pro_tag.handle = tag;
            const tag_title = tag.replace(coll_handle, '').replace(/[-\s]/g, ' ').trim();
            coll_pro_tag.title = tag_title;
            product_tags.push(coll_pro_tag);
          }
          if (tag.match('cart-limit')) {
            const cartLimit = tag.replace('cart-limit-', '');
            product.cart_limit = parseFloat(cartLimit);
            // console.log(product);
          }
        });

        app.collection.products.push(product);
        app.collection.collection_handle = $('.patterns_categories').attr('data-collection');
        if (product_tags.length) {
          app.collection.tags = product_tags;
        } else {
          app.collection.tags = '0';
        }
      });
    },

    _filtersCreateUrl(e) {
      const b = $.param(Shopify.queryParams).replace(/%2B/g, '+');
      return e ? b !== '' ? `${e}?${b}` : e : `${location.pathname}?${b}`;
    },

    _filterAjaxCall(e) {
      delete Shopify.queryParams.page;
      const url = app._filtersCreateUrl(e);
      history.push(url, {
        param: Shopify.queryParams,
      });
      app._getNewTitle(Shopify.queryParams);
      app._getCollFilteredProducts(url);
    },

    _getNewTitle(queryParams) {
      let tagParams = '';
      let pageParams = '';
      let finalParams = '';
      const title = document.title;
      const collection = title.slice(0, title.indexOf('-')).replace(/\s/g, '');
      const siteTitle = title.slice(title.lastIndexOf('-') + 1).replace(/\s/g, '');

      if (queryParams.constraint) {
        tagParams = ` - Tagged "${queryParams.constraint.replace(/\+/g, ', ')}"`;
      }

      if (queryParams.page) {
        pageParams = ` - Page ${queryParams.page}`;
      }

      finalParams = `${tagParams}${pageParams}`;
      const newTitle = `${collection}${finalParams} - ${siteTitle}`;
      document.title = newTitle;
    },

    _getCollFilteredProducts(url) {
      if (Shopify.designMode) {
        return;
      }

      const limit = $('[data-template="collection"]').data('pagination-limit');
      const search = $.param(Shopify.queryParams);
      app.collection.products = [];
      app.isLoading = true;

      url += (search.length) ? '&view=products.json' : 'view=products.json';

      // for Shopify theme editor
      if (Shopify.designMode) {
        url = `/admin/products.json?limit=${limit}`;
      }

      axios.get(url)
        .then((response) => {
          app.isLoading = false;
          const productsData = [];

          response.data.products.forEach((item) => {
            const product = item.product;

            // add default current_variant object
            product.current_variant = product.variants[0];

            // add product options
            product.options_with_values = item.options_with_values;

            // add cart limit tag
            product.tags.forEach((tag) => {
              if (tag.match('cart-limit')) {
                const cartLimit = tag.replace('cart-limit-', '');
                product.cart_limit = parseFloat(cartLimit);
              }
            });

            // exclude products that have the app.productExcludeTag (theme settings)
            if (product.tags.indexOf(app.productExcludeTag) === -1) {
              productsData.push(product);
            }
          });

          app.collection.products = productsData;

          // reinitialize product reviews for each grid item
          app._getCollectionReviews();

          // reinitialize tooltips but only for desktop
          if (!detectIt.hasTouch) {
            setTimeout(() => {
              $('[data-toggle="tooltip"]').tooltip();
            }, 100);
          }

          $('html').animate({
            scrollTop: $('html').offset().top,
          }, 400);
          // unlock window - fix scrolltop common problem
          $(window).bind('mousewheel', () => {
            $('html').stop();
          });
          return response;
        })
        .catch((error) => {
          // console.log(error);
          throw error;
        });
    },

  },
};

export default collectionMethods;

